import React, { Fragment } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { BackButton, EditButton } from "../../../Components/Utils/Buttons";
import { SecondHeading } from "../../../Components/Utils/Heading";
import { NuInput, NuInputfile, NuTextArea } from "../../../Components/Utils/Input";
import { useFormik } from "formik";
import Breadcrumb from "../../../Components/Utils/Breadcrumb";

function ViewForms() {
  const { formsViewId } = useParams();
  const location = useLocation();
  const data = location.state.data;
  const pageIndex = location.state?.pageIndex;
  const searchQuery = location.state?.searchQuery;

  console.log("data - TEST", data);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {},
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (value, { resetForm }) => {},
  });

  return (
    <div className="w-full h-full py-2 px-4 ">
      <div className="flex justify-between ">
        <Breadcrumb
          items={[
            {
              name: "Forms",
              link: "/forms/",
            },
            { name: "View" },
          ]}
        />
        <div className=" flex gap-2">
          <Link
            to={`/forms`}
            state={{
              currentPage: pageIndex,
              searchQuery: searchQuery != "" ? searchQuery : "",
            }}
          >
            <BackButton link={true} />
          </Link>
        </div>
      </div>
      <div className="w-full mx-auto h-[calc(100vh-145px)] bg-white rounded-md mt-4 overflow-y-scroll p-3">
        <SecondHeading title={`${data.formName || ""}`} />
        <div className=" w-full">
          {data?.titles &&
            data?.titles.map((item, i) => {
              console.log("subItem", item);

              return (
                <div key={i}>
                  <div className="w-full my-0.5 flex justify-between items-center bg-slate-100 text-[#111537] border-y border-[#e8ecf9]">
                    <p className=" py-3 px-3 text-sm 2xl:text-base font-medium  ">
                      {item.titleName || " - "}
                    </p>
                  </div>
                  <div className=" w-full flex flex-wrap justify-start items-start py-2 px-4">
                    {item?.fields &&
                      item.fields.map((subItem, j) => {
                        function giveValue(value, formik) {
                          console.log("value", value);
                          switch (value?.field_type) {
                            case "text":
                              return (
                                <>
                                  <div
                                    className={`w-full py-2 text-xs 2xl:text-sm `}
                                  >
                                    <table className="w-full">
                                      <tr>
                                        <td className="w-3/5">
                                          <p>{value?.field_label || "  "}</p>
                                        </td>
                                        <td className="w-2/5">
                                          <NuInput
                                            label={""}
                                            type={value?.type}
                                            formik={formik}
                                            placeholder={value?.Name}
                                            name={value?.value}
                                            width={"w-full"}
                                          />
                                        </td>
                                      </tr>
                                    </table>
                                  </div>
                                </>
                              );
                            case "string":
                              return (
                                <>
                                  <div
                                    className={` ${value?.width} py-2 text-xs 2xl:text-sm mt-5 `}
                                  >
                                    <table className="w-full">
                                      <tr>
                                        <td className="w-full">
                                          <p>{value?.Name}</p>
                                        </td>
                                      </tr>
                                    </table>
                                  </div>
                                </>
                              );
                            case "yesno":
                              return (
                                <>
                                  <div
                                    className={`w-full py-2 text-xs 2xl:text-sm  mt-5`}
                                  >
                                    <table className="w-full">
                                      <tr>
                                        <td className="w-3/5">
                                          <p>{value?.field_label}</p>
                                        </td>
                                        {[
                                          { label: "Yes", type: "checkbox" },
                                          { label: "No", type: "checkbox" },
                                          { label: "N/A", type: "checkbox" },
                                        ] &&
                                          [
                                            { label: "Yes", type: "checkbox" },
                                            { label: "No", type: "checkbox" },
                                            { label: "N/A", type: "checkbox" },
                                          ].map((item, k) => {
                                            return (
                                              <td key={k}>
                                                <div className="flex justify-center items-center gap-2">
                                                  <p>{item?.label || ""}</p>
                                                  <input type="checkbox" />
                                                </div>
                                              </td>
                                            );
                                          })}
                                      </tr>
                                    </table>
                                  </div>
                                </>
                              );
                            case "checkbox":
                                    return (
                                      <>
                                        <div className={`w-full py-2 text-xs 2xl:text-sm  mt-5`}>
                                          <table className="w-full">
                                            <tr>
                                              <td className="w-3/5">
                                                <p>{value?.field_label}</p>
                                              </td>
                                              {value?.metadata &&
                                                Object.entries(value?.metadata).map(([key, valueOf]) => (
                                                  <td key={valueOf}>
                                                    <div className="flex justify-end items-center gap-2 w-[200px]">
                                                      <p>{key || ""}</p>
                                                      <input type="checkbox" />
                                                    </div>
                                                  </td>
                                                ))}
                                            </tr>
                                          </table>
                                        </div>
                                      </>
                                    );
                            case "observation":
                              return (
                                <>
                                  <NuTextArea
                                    label=""
                                    placeholder={value?.field_label || ""}
                                    formik={formik}
                                    name={value?.field_label}
                                    new_width={"w-full"}
                                  />
                                </>
                              );
                            case "textArea":
                              return (
                                <>
                                  <NuTextArea
                                    label=""
                                    placeholder={value?.field_label || ""}
                                    formik={formik}
                                    name={value?.field_label}
                                    new_width={"w-full"}
                                  />
                                </>
                              );
                            case "date":
                              return (
                                <>
                                  <div
                                    className={` ${value?.width} py-2 text-xs 2xl:text-sm `}
                                  >
                                    <table className="w-full">
                                      <tr>
                                        <td className="w-3/5">
                                          <p>{value?.Name}</p>
                                        </td>
                                        <td className="w-2/5">
                                          <NuInput
                                            label={""}
                                            type={value?.type}
                                            formik={formik}
                                            placeholder={value?.Name}
                                            name={value?.value}
                                            width={"w-full"}
                                          />
                                        </td>
                                      </tr>
                                    </table>
                                  </div>
                                </>
                              );
                            case "time":
                              return (
                                <>
                                  <div
                                    className={` ${value?.width} py-2 text-xs 2xl:text-sm `}
                                  >
                                    <table className="w-full">
                                      <tr>
                                        <td className="w-3/5">
                                          <p>{value?.Name}</p>
                                        </td>
                                        <td className="w-2/5">
                                          <NuInput
                                            label={""}
                                            type={value?.type}
                                            formik={formik}
                                            placeholder={value?.Name}
                                            name={value?.value}
                                            width={"w-full"}
                                          />
                                        </td>
                                      </tr>
                                    </table>
                                  </div>
                                </>
                              );
                            case "file":
                              return (<>
                              <NuInputfile
                               label={""}
                               name={value?.field_label} 
                               handleChange={()=>{}}
                               width={"w-full"}
                               placeholder="file upload"
                              />
                              </>);
                            case "imagePath":
                                    return (
                                      <>
                                        <NuInputfile
                                          label={""}
                                          name={value?.field_label}
                                          handleChange={() => {}}
                                          width={"w-full"}
                                          placeholder="file upload"
                                        />
                                      </>
                                    );
                            case "table-data":
                              return (
                                <>
                                  <div className=" w-full">
                                    <table className=" w-full border text-xs 2xl:text-sm ">
                                      <thead>
                                        <tr>
                                          {value?.value &&
                                            value?.value.map((item, k) => {
                                              return (
                                                <th
                                                  key={k}
                                                  className="text-left py-2 px-4 border"
                                                >
                                                  {item?.label || ""}
                                                </th>
                                              );
                                            })}
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {Array(10)
                                          .fill(0)
                                          .map((_, i) => (
                                            <tr key={i}>
                                              {value?.value &&
                                                value?.value.map((item, k) => {
                                                  return (
                                                    <td
                                                      key={k}
                                                      className="text-left py-2 px-4  h-8 border"
                                                    >
                                                      {""}
                                                    </td>
                                                  );
                                                })}
                                            </tr>
                                          ))}
                                      </tbody>
                                    </table>
                                  </div>
                                </>
                              );
                            case "multi":
                              return (
                                <>
                                  <div className=" w-full">
                                    {value?.metadata &&
                                    Object.keys(value?.metadata).length > 3 ? (
                                      <div className="grid grid-cols-4 gap-2 items-center text-xs 2xl:text-sm">
                                        {Object.entries(value?.metadata).map(
                                          ([key, valueOf],i) => (
                                            <>
                                              {valueOf == "text" ? (
                                                <div
                                                  className={`${
                                                    Object.keys(value?.metadata)
                                                      .length >= 3
                                                      ? " w-full"
                                                      : " w-full"
                                                  } flex gap-3 items-center ${(i + 1) % 4 !== 1 ? "text-end" : "text-start"}`}
                                                >
                                                  <p className=" w-1/2">
                                                    {key || ""}
                                                  </p>
                                                  <NuInput
                                                    label={""}
                                                    type={value?.type}
                                                    formik={formik}
                                                    placeholder={value?.Name}
                                                    name={value?.value}
                                                    width={"w-full"}
                                                  />
                                                </div>
                                              ) : value == "string" ? (
                                                <div className=" w-full">
                                                  <p className=" w-full">
                                                    {key || ""}
                                                  </p>
                                                </div>
                                              ) : (
                                                <div className="w-full">
                                                  <p className="">
                                                    {key || ""}
                                                  </p>
                                                </div>
                                              )}
                                            </>
                                          )
                                        )}
                                      </div>
                                    ) : (
                                      <>
                                        <table className="w-full ">
                                          <tr>
                                            {value?.metadata &&
                                              Object.entries(
                                                value?.metadata
                                              ).map(([key, valueOf]) => (
                                                <>
                                                  <td
                                                    key={key}
                                                    className=" text-xs 2xl:text-sm text-end first:text-start"
                                                  >
                                                    {valueOf == "text" ? (
                                                      <div
                                                        className={`w-full flex gap-3 items-center`}
                                                      >
                                                        <p className=" w-1/2 ">
                                                          {key || ""}
                                                        </p>
                                                        {/* <p className=" min-w-[500px]">{Object.keys(value?.metadata).length || "#"}</p> */}
                                                        <NuInput
                                                          label={""}
                                                          type={value?.type}
                                                          formik={formik}
                                                          placeholder={
                                                            value?.Name
                                                          }
                                                          name={value?.value}
                                                          width={"w-full"}
                                                        />
                                                      </div>
                                                    ) : value == "string" ? (
                                                      <>
                                                        <p>{key || ""}</p>
                                                      </>
                                                    ) : (
                                                      <>
                                                        <p>{key || ""}</p>
                                                      </>
                                                    )}
                                                  </td>
                                                </>
                                              ))}
                                          </tr>
                                        </table>
                                      </>
                                    )}
                                  </div>
                                </>
                              );
                            case "tableRow":
                              return (
                                <>
                                  <table className="w-full text-xs 2xl:text-sm ">
                                    <tr>
                                      <td className="w-2/12">
                                        <p>{value?.field_label}</p>
                                      </td>
                                      {
                                        <>
                                          {Object.entries(value?.metadata).map(
                                            ([key, valueOf]) => (
                                              <>
                                                {valueOf == "text" ? (
                                                  <td
                                                    className={`${
                                                      Object.keys(
                                                        value?.metadata
                                                      ).length >= 3
                                                        ? " "
                                                        : " "
                                                    } flex gap-3 items-center text-end first:text-start`}
                                                  >
                                                    <p className=" w-1/2">
                                                      {key || ""}
                                                    </p>
                                                    <NuInput
                                                      label={""}
                                                      type={value?.type}
                                                      formik={formik}
                                                      placeholder={value?.Name}
                                                      name={value?.value}
                                                      width={"w-full"}
                                                    />
                                                  </td>
                                                ) : valueOf == "string" ? (
                                                  <td className=" ">
                                                    <p className=" ">
                                                      {key || ""}
                                                    </p>
                                                  </td>
                                                ) : valueOf == "string" ?(
                                                  <td
                                                  className={`${
                                                    Object.keys(
                                                      value?.metadata
                                                    ).length >= 3
                                                      ? " "
                                                      : " "
                                                  } flex gap-3 items-center`}
                                                >
                                                  <p className=" w-1/2">
                                                    {key || ""}
                                                  </p>
                                                  <NuInput
                                                    label={""}
                                                    type={"date"}
                                                    formik={formik}
                                                    placeholder={value?.Name}
                                                    name={value?.value}
                                                    width={"w-full"}
                                                  />
                                                </td>
                                                )
                                                :
                                                (
                                                  <td className=" ">
                                                    <p className="">
                                                      {key || ""}
                                                    </p>
                                                  </td>
                                                )}
                                              </>
                                            )
                                          )}
                                        </>
                                      }
                                    </tr>
                                  </table>
                                </>
                              );
                            case "tableHeaders":
                              return (
                                <>
                                  <table className="w-full text-xs 2xl:text-sm ">
                                    <tr>
                                      <td className="w-2/12">
                                        <p>{value?.field_label}</p>
                                      </td>
                                      {
                                        <>
                                          {Object.entries(value?.metadata).map(
                                            ([key, valueOf]) => (
                                              <>
                                                {valueOf == "text" ? (
                                                  <td
                                                    className={`${
                                                      Object.keys(
                                                        value?.metadata
                                                      ).length >= 3
                                                        ? " "
                                                        : ""
                                                    } flex gap-3 items-center`}
                                                  >
                                                    <p className=" w-1/2">
                                                      {key || ""}
                                                    </p>
                                                    <NuInput
                                                      label={""}
                                                      type={value?.type}
                                                      formik={formik}
                                                      placeholder={value?.Name}
                                                      name={value?.value}
                                                      width={"w-full"}
                                                    />
                                                  </td>
                                                ) : value == "string" ? (
                                                  <td className=" ">
                                                    <p className=" ">
                                                      {key || ""}
                                                    </p>
                                                  </td>
                                                ) : (
                                                  <td className="">
                                                    <p className="">
                                                      {key || ""}
                                                    </p>
                                                  </td>
                                                )}
                                              </>
                                            )
                                          )}
                                        </>
                                      }
                                    </tr>
                                  </table>
                                </>
                              );
                            default:
                              return <>{value.type}</>;
                          }
                        }
                        return (
                          <Fragment key={j}>
                            {giveValue(subItem, formik)}
                          </Fragment>
                        );
                      })}
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
}

export default ViewForms;
